"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe, Check } from "lucide-react";

type Language = "th" | "en";

interface LanguageToggleProps {
    variant?: "default" | "ghost" | "outline";
    showLabel?: boolean;
}

const languages: Record<Language, { label: string; flag: string }> = {
    th: { label: "ไทย", flag: "🇹🇭" },
    en: { label: "English", flag: "🇬🇧" },
};

export function LanguageToggle({ variant = "ghost", showLabel = false }: LanguageToggleProps) {
    const [currentLang, setCurrentLang] = useState<Language>("th");

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant={variant}
                    size={showLabel ? "default" : "icon"}
                    className="gap-2"
                    aria-label="เลือกภาษา"
                >
                    <Globe className="h-4 w-4" />
                    {showLabel && (
                        <span className="hidden sm:inline">
                            {languages[currentLang].flag} {languages[currentLang].label}
                        </span>
                    )}
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {(Object.entries(languages) as [Language, typeof languages.th][]).map(([key, { label, flag }]) => (
                    <DropdownMenuItem
                        key={key}
                        onClick={() => setCurrentLang(key)}
                        className="gap-2"
                    >
                        <span>{flag}</span>
                        <span>{label}</span>
                        {currentLang === key && <Check className="h-4 w-4 ml-auto" />}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
